<template>
  <div class="text-field-wrapper">
    <div class="row">
      <div class="col">
          <label v-if="label" :for="inputId" :class="['form-label', { 'text-danger': error }]">
              {{ label }}
              <span v-if="required" class="text-danger">*</span>
          </label>
      </div>

      <div v-if="infoTooltipLabel" class="col text-end">
          <span
              class="d-inline-block"
              v-tooltip="{
                text: infoTooltipLabel,
                theme: {
                  color: '#fff',
                  placement: 'left',
                  backgroundColor: '#000000'
                }
              }"
          >
              <i class="bi bi-info-circle-fill text-muted"></i>
          </span>
      </div>
    </div>

    <div class="position-relative mb-3">
        <input
            :id="inputId"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': error }"
            :value="modelValue"
            :placeholder="placeholder"
            :disabled="disabled"
            :readonly="readonly"
            @input="updateValue"
        />

        <span v-if="clearable && modelValue && !disabled && !readonly" class="input-clear-button" @click="clearInput">
            <i class="bi bi-x"></i>
        </span>
    </div>

    <div v-if="error" class="text-danger mt-1">{{ error }}</div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue"
import { v4 as uuidv4 } from "uuid"

const props = defineProps({
    modelValue: String,
    label: String,
    placeholder: String,
    error: String,
    infoTooltipLabel: String,
    required: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    clearable: Boolean
})

const emit = defineEmits(["update:modelValue"])
const inputId = `input-${uuidv4()}`

function updateValue(e) {
    emit("update:modelValue", e.target.value)
}

function clearInput() {
    emit("update:modelValue", "")
}
</script>

<style scoped>
    .input-clear-button {
        position: absolute;
        right: 2px;
        z-index: 2;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        cursor: pointer;
        line-height: 0;
        font-size: 1.5em;
        color: #89181A;
    }
</style>